.page {
  min-height: 100svh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: var(--spacing-12) var(--spacing-4);
  background:
    radial-gradient(
      circle at top left,
      color-mix(in oklch, var(--control-bg-accent) 12%, transparent),
      transparent 30%
    ),
    linear-gradient(180deg, var(--surface-bg-secondary), var(--surface-bg-primary));
}

.shell {
  width: min(100%, var(--layout-max-width-md));
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-5);
}

.fieldRow {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-5);
}

.fieldRow > * {
  flex: 1;
  min-inline-size: 0;
}

.field,
.fieldSpan {
  display: grid;
  gap: var(--spacing-2);
}

.fieldSpan {
  grid-column: 1 / -1;
}

.fieldset {
  display: grid;
  gap: var(--spacing-3);
  grid-column: 1 / -1;
  margin: 0;
  padding: 0;
  border: 0;
  min-inline-size: 0;
}

.fieldsetLegend {
  display: block;
  margin: 0;
  padding: 0 0 var(--spacing-1);
  min-inline-size: 0;
  line-height: var(--leading-normal);
}

.labelRow {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: var(--spacing-3);
  flex-wrap: wrap;
}

.label {
  color: var(--text-primary);
  font-size: var(--text-md);
  font-weight: var(--font-weight-bold);
  user-select: none;
  -webkit-user-select: none;
}

.requirementBadge {
  align-self: center;
}

.fieldMeta {
  display: block;
}

.fieldMetaMessage {
  display: block;
  font-size: var(--text-md);
  line-height: var(--leading-normal);
}

.fieldMetaMessage {
  color: var(--text-secondary);
}

.fieldMetaMessageError {
  color: var(--text-error);
}

.invalidShakeWrapper {
  display: grid;
  gap: inherit;
  min-inline-size: 0;
}

.hint {
  margin: 0;
  color: var(--text-secondary);
  font-size: var(--text-md);
  line-height: var(--leading-normal);
  user-select: none;
  -webkit-user-select: none;
}

.selectTrigger {
  min-height: var(--control-height-m);
  border-radius: var(--radius-lg);
  padding: 0 var(--spacing-3p5);
  font: inherit;
}

.selectContent {
  /* WHY: Timezone labels can be long and the menu is intentionally taller than default selects for scanning. */
  max-height: min(24rem, var(--radix-select-content-available-height));
}

.errorField {
  border-color: var(--text-error);
}

.consentField {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: var(--spacing-3);
  padding: var(--spacing-3p5);
  border: 1px solid var(--surface-border-primary);
  border-radius: var(--radius-lg);
  background: var(--surface-bg-secondary);
}

.consentCheckbox {
  align-self: start;
  margin-top: var(--spacing-0p5);
}

.consentBody {
  display: grid;
  gap: var(--spacing-2);
}

.consentText {
  color: var(--text-primary);
  font-size: var(--text-md);
  line-height: var(--leading-relaxed);
  cursor: pointer;
}

.success {
  display: grid;
  place-items: center;
  gap: var(--spacing-4);
  padding: var(--spacing-10) 0 var(--spacing-2);
  text-align: center;
}

.successIcon {
  color: var(--control-bg-accent);
}

.successTitle {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--text-2xl);
  user-select: none;
  -webkit-user-select: none;
}

.successText {
  max-width: var(--modal-width-md);
  margin: 0;
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
  cursor: default;
}

.successActions {
  display: flex;
  justify-content: center;
}

.successNote {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.loading {
  display: grid;
  place-items: center;
  gap: var(--spacing-4);
  min-height: 50vh;
  color: var(--text-secondary);
}

.skeletonHeader {
  display: grid;
  gap: var(--spacing-3);
  padding: var(--spacing-2) 0;
}

.skeletonCard {
  width: 100%;
  max-width: var(--modal-width-sm);
  min-height: clamp(20rem, 38vh, 30rem);
  border-radius: var(--radius-3xl);
  overflow: hidden;
  margin: 0 auto;
}

.skeletonProgressBarTrack {
  height: var(--spacing-1);
  width: 100%;
  background-color: var(--surface-bg-tertiary);
}

.skeletonGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--spacing-5);
}

@media (min-width: 1024px) {
  .skeletonCard {
    max-width: var(--layout-max-width-md);
  }
}

@media (max-width: 800px) {
  .fieldRow {
    flex-direction: column;
  }

  .skeletonGrid {
    grid-template-columns: 1fr;
  }
}
